module.exports = __webpack_public_path__ + "static/media/red-graph.d08c47ea.png";